import React from "react";
import "./loader.css";

const RecentActivity = ({ count }: { count: number }) => {
  return (
    <>
      {count > 0 && (
        <div className='flex gap-x-4 justify-start'>
          {Array.from({ length: count }).map((item: any, index: number) => (
            <div key={index}>
              <div
                key={index}
                className='flex gap-2 2xl:items-center items-start border bg-white animate-pulse shadow-customShadow7 border-[#e6e6e6] rounded-lg py-3.5 px-3 w-[336px] cursor-pointer'
              >
                <div className='w-[72px] h-[72px] rounded-full bg-gray-200 flex-shrink-0'></div>
                <div className='w-full'>
                  <div className='h-6 bg-gray-200 rounded mb-3'></div>
                  <div className='h-6 bg-gray-200 rounded'></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default RecentActivity;
